// MUI
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { styles } from "components/styles";

// Constants
import CustomButton from "constants/CustomButton";

const ConfirmModal = (props) => {
  const {
    open,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText,
    loadingAction,
  } = props;
  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle sx={styles.typographyTitle}>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions
        sx={{ alignItems: "center", justifyContent: "center", mb: 1 }}
      >
        <CustomButton
          label="Cancel"
          disabled={loadingAction}
          onClick={onCancel}
          type="secondary"
        />
        <CustomButton
          disabled={loadingAction}
          onClick={onConfirm}
          label={
            <>
              {loadingAction && (
                <CircularProgress sx={{ mr: 1 }} size={20} color="inherit" />
              )}
              {confirmText}
            </>
          }
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
